import { createSelector } from 'reselect';
import { ArmyListEditView } from './view/ArmyListEditView';
import {
  getArmyList,
  getArmyListState,
} from '../make/unit/edit/selector/editSelector';
import { getFolders } from '../common/selector';
import { FolderView } from '../common/ArmyListView';

export const armyListEditPresenter = createSelector(
  [getArmyList, getArmyListState, getFolders],
  (armyList, armyListState, folders): ArmyListEditView => {
    return new ArmyListEditView({
      name: armyList?.name ?? '',
      folderId: armyList?.folderId ?? null,
      folders: folders.map(
        (item) =>
          ({
            id: item.id,
            name: item.name,
            parentId: item.parentId,
            isShare: item.isShare,
            parentName: null,
          }) satisfies FolderView as FolderView,
      ),
      max: armyList?.max ?? 4500,
      isPrivate: armyList?.isPrivate ?? false,
      notes: armyList?.notes ?? '',
      canSubmit: !armyListState,
    });
  },
);
